module.exports = __webpack_public_path__ + "static/media/stol_ontour_300x70.06faeb0f.svg";